<template>
  <el-dialog top="1px" :title="inputTitle" :visible.sync="isVisible" width="500px" :close-on-click-modal="false"
             :close-on-press-escape="false" :fullscreen="false" @close="stopChat">

    <!-- <div style="width: 100%; height: 75vh; padding-top: 30px; ">
      
    </div> -->
    <voice-chat-view ref="voiceChatView" @stop="stopChat"></voice-chat-view>
  </el-dialog>
</template>

<script>


import VoiceChatView from './voice_chat_view'

export default {
  name: 'VoiceChatDialogCustom',

  data() {
    return {
      isVisible: false,
      inputTitle: '',
    };
  },
  beforeDestroy() {

  },
  components: {
    VoiceChatView
  },

  methods: {

    show(agentItemId, title) {
      this.agentItemId = agentItemId
      this.inputTitle = title
      this.isVisible = true
      this.$nextTick(() => {
        this.$refs.voiceChatView.init(agentItemId)
      })
    },

    stopChat() {
      this.$refs.voiceChatView.stopChat()
      this.isVisible = false
    },

  }
};
</script>

<style scoped>
::v-deep .el-dialog {
  background-image: url('https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250318/c83d7e3faf9bbd8eb1eee01a31898a9f-742289907455696785.png');
  background-size: 100% 100%;
}
</style>
